import { EXAMPLE_QUESTIONS } from '../../constants/loading-messages';

export const MatchmakingEmptyState = () => {
  return (
    <div className="flex flex-col items-center justify-center py-12 px-4">
      <div className="w-full max-w-4xl">
        <div className="rounded-2xl border border-[#E4E5EA] bg-white overflow-hidden">
          {/* Content */}
          <div className="px-6 py-6">
            <div className="space-y-4">
              {/* Headline */}
              <h2 className="text-2xl font-bold text-gray-900">
                Find the Right Provider — Faster
              </h2>

              {/* Main Description - Paragraph 1 */}
              <p className="text-gray-700 leading-relaxed">
                The bQuest Navigator helps you quickly identify the best-fit service providers for your unique care needs.
              </p>

              {/* Main Description - Paragraph 2 */}
              <p className="text-gray-700 leading-relaxed">
                Instead of searching by basic keywords, Navigator uses AI-powered matchmaking to understand the full situation, care needs, preferences, urgency, and lifestyle factors, and then recommends providers that are most likely to be a strong match.
              </p>

              {/* Main Description - Paragraph 3 */}
              <p className="text-gray-700 leading-relaxed">
                It looks beyond location and service type by evaluating deeper factors like care approach, service delivery style, and compatibility to help you make accurate connections faster.
              </p>

              {/* Examples Section */}
              <div className="mt-6">
                <h3 className="text-gray-700 leading-relaxed font-medium mb-4">
                  Here are a couple of examples of the level of detail that helps Navigator find the best provider match:
                </h3>

                {/* Examples - Rendered as ordered list for better accessibility */}
                <ol className="space-y-4" aria-label="Search query examples">
                  {EXAMPLE_QUESTIONS.map((example, index) => (
                    <li key={index} className="bg-gray-50 rounded-lg p-4 border border-gray-200">
                      <h4 className="font-semibold text-gray-900 mb-2">Example {index + 1}:</h4>
                      <p className="text-gray-700 leading-relaxed">
                        {example}
                      </p>
                    </li>
                  ))}
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
